export var BANNER_TEXT = {
  NEW: 'new',
  LIMITED: 'limited time offer',
  NERDWALLET: 'nerdwallet exclusive'
};
export var SEARCH_TEXT = {
  NEW: 'new!',
  LIMITED: 'limited time offer',
  NERDWALLET: 'nerdwallet exclusive'
};